let isSspLoaded = false

const getUrlParam = (parameterName) => {
	const results = new RegExp('[?&]' + parameterName + '=([^&#]*)').exec(window.location.href)

	if (results == null) {
		return null
	}

	return decodeURI(results[1]) || 0
}

const setUtmForExternalLinks = () => {
	document.querySelectorAll('a.rsswidget').forEach((link) => {
		const url = link.getAttribute('href')
		const newUrl =
			url + '?utm_source=' + (getUrlParam('utm_source') || 'www.seznam.cz') + '&utm_medium=' + (getUrlParam('utm_medium') || 'sekce-z-internetu')

		link.setAttribute('href', newUrl)
	})
}

export const repeaterAd = () => {
	const repeaterAd = document.querySelector('.sidebar-sticky-ad')
	const zoneId = parseInt(repeaterAd.getAttribute('data-repeater-zone-id'))

	if (window.innerWidth > 992 && repeaterAd) {
		const content = document.getElementById('content')
		const sidebar = document.querySelector('#sidebar')
		const spaceForAd = 1500
		const spaceForAdds = content.offsetHeight - sidebar.querySelector('.side-section').offsetHeight
		const places = Math.floor(spaceForAdds / spaceForAd)

		for (let i = 1; i <= places; i++) {
			let newChild = document.createElement('div')
			newChild.classList.add('widget-sssp__item')

			let sspZone = document.createElement('div')
			sspZone.setAttribute('id', 'ssp-zone-' + zoneId + '-' + i)

			newChild.appendChild(sspZone)
			repeaterAd.appendChild(newChild)

			window.ads.seznamAds = window.ads.seznamAds || []
			window.ads.seznamAds.push({
				zoneId: zoneId,
				id: 'ssp-zone-' + zoneId + '-' + i,
				width: 300,
				height: 600
			})
			window.ads.loadSeznamAds()
		}

		setTimeout(() => {
			sidebar.classList.add('repeater-ads-loaded')
		}, 1000)
	}
}

export const setBranding = (advert, data) => {
	// Pokud přišel branding bude šířka reklamy 2000
	if (advert.width === 2000) {
		document.querySelector('body').classList.add('branding-enabled')
	}

	// Když jsou úpravy hotové, řekneme SSSP aby vydalo reklamu
	return sssp.writeAd(advert, data)
}

export const loadSeznamAds = () => {
	if (!isSspLoaded || window.ads.seznamAds === undefined || !window.ads.seznamAds) {
		return
	}

	const ads = window.ads.seznamAds

	// console.log('getAdsByTags')
	//
	// sssp.getAdsByTags()
	//
	// document.querySelectorAll('[data-szn-ssp-ad]').forEach((element) => {
	//     element.removeAttribute('data-szn-ssp-ad')
	// })

	sssp.getAds(ads)
	window.ads.seznamAds = []
}

export const onloadSeznamSsp = () => {
	isSspLoaded = true

	if (window.themeConfig.seznamCmpId) {
		sssp.config({
			webId: window.themeConfig.seznamCmpId
		})
		console.log('cmp načteno')
	}

	if (sssp.displaySeznamAds() || getUrlParam('utm_source') === 'seznam_hp') {
		sssp.config({
			source: 'hp_feed'
		})
	}

	loadSeznamAds()
}

export const init = () => {
	let scriptTag = document.createElement('script')
	scriptTag.setAttribute('src', 'https://ssp.seznam.cz/static/js/ssp.js')
	scriptTag.setAttribute('defer', 'defer')
	scriptTag.setAttribute('onload', 'window.ads.onloadSeznamSsp()')
	document.body.appendChild(scriptTag)

	setUtmForExternalLinks()
}
